import { HeTimesheetsEdit } from "@/features"

const HeTimesheetsEditPage = () => {
  return <HeTimesheetsEdit />
}

export default HeTimesheetsEditPage